import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useMemo } from "react";
import { isDevOrTestStage } from "~/swr-hooks/utils";
import { useWorkspaceRoles } from "~/swr-hooks/workspaces/useWorkspaceRoles";
import { reportErrorToBugsnag } from "~/utils/ErrorUtils";
const defaultValue = {
    data: undefined
};
const WorkspaceRolesProviderContext = /*#__PURE__*/ createContext(defaultValue);
export const WorkspaceRolesProvider = (param)=>{
    let { children } = param;
    const { data, error } = useWorkspaceRoles();
    const value = useMemo(()=>({
            data,
            error
        }), [
        data,
        error
    ]);
    return /*#__PURE__*/ _jsx(WorkspaceRolesProviderContext.Provider, {
        value: value,
        children: children
    });
};
export const useWorkspaceRolesContext = ()=>{
    const context = useContext(WorkspaceRolesProviderContext);
    if (context === defaultValue) {
        const error = "WorkspaceRolesProviderContext used outside of WorkspaceRolesProvider";
        if (isDevOrTestStage()) {
            throw error;
        } else {
            reportErrorToBugsnag({
                error,
                context: error
            });
        }
    }
    return context;
};
